import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const HelpLazy = lazyLoader(
  () => import('./Help' /* webpackChunkName: "help" */),
);

const Help = () => {
  return (
    <Suspense fallback={null}>
      <HelpLazy />
    </Suspense>
  );
};

export default Help;
